module.exports = __webpack_public_path__ + "assets/kaoqinguanli.4ba44704.svg";